import React from 'react';
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import RegisterProgramForm from '../../../components/form/register-program-form/RegisterProgramForm';
// import { Link } from 'react-router-dom';

const EventData = [
	{
		"id": 1,
		"title": "Seafood Properties Prediction",
		"image": "seafood_properties_prediction.webp",
		// "website": "https://ovet.app/",
		// "industry": "Healthcare",
		// "rating": "4.8 Google Rating",
		// "duration": "12 Weeks",
		"category": "Maritime / Food Processing",
		"location": "https://this.fish/",
		// "going": "140+",
		"company": "This Fish"
	}
]

const SeafoodPropertiesPrediction = ({
	showRegisterForm,
	setShowRegisterForm,
	company
	}) => {
	const eventItem = EventData[0];
	return (
		<>
			<SEO
				title={ eventItem.title }
				description=""
			/>
			<Layout>
				<BreadcrumbOne 
					title={eventItem.title}
					rootUrl="/programs/work-integrated-learning"
					parentUrl="Industry Partner Work Integrated Learning"
					currentUrl={eventItem.title}
				/>
				<div className="edu-event-details-area edu-event-details edu-section-gap bg-color-white">
					<div className="container">
						<div className="row g-5">
							<div className="col-lg-12">
								<div className="thumbnail">
									<img src={`${process.env.PUBLIC_URL}/images/project-details/${ eventItem.image }`} alt="Event Thumb" />
								</div>
							</div>
						</div>
						<div className="row g-5">
							<div className="col-lg-7">
								<div className="content">
									<h3 className="title">{ eventItem.title }</h3>
									<p>
										<strong>What is the main goal for this project?</strong><br></br>
										This project explores how computer vision and machine learning can be applied to automate quality assessment processes in food and natural resource industries. The primary objective is to build AI models that analyze images of physical products to estimate key attributes such as size, shape, and classification—enabling faster, more consistent inspections in operational environments.
									</p>
									<p className="mb-0">
										<strong>What tasks will learners need to complete to achieve the project goal?</strong><br></br>
									</p>
									<ul>
										<li>
											Prepare and label image datasets for training and evaluation.
										</li>
										<li>
											Train and fine-tune deep learning models for feature detection and attribute prediction.
										</li>
										<li>
											Apply image segmentation and preprocessing techniques to isolate relevant regions.
										</li>
										<li>
											Build modular prediction pipelines that can support multiple output types (e.g., size, category).
										</li>
										<li>
											Conduct performance benchmarking, model tuning, and accuracy analysis.
										</li>
										<li>
											Contribute to the development of inference tools suitable for real-time or batch processing.
										</li>
									</ul>
									<p className="mb-0">
										These tasks help learners build expertise in applied AI and computer vision with practical use cases.
									</p>
									<p className="mb-0">
										<strong>How will you support learners in completing the project?</strong><br></br>
										Learners will work under the guidance of experienced AI mentors through structured sprints and feedback loops. They'll gain access to curated datasets, GPU-based training environments, and collaborative tools. Regular check-ins, code reviews, and learning checkpoints ensure that learners make meaningful contributions while developing in-demand technical skills.
									</p>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="eduvibe-sidebar">
									<div className="eduvibe-widget eduvibe-widget-details">
										<h5 className="title">ABOUT INDUSTRY PARTNER</h5>
										<div className="widget-content">
											<ul>
												{/* <li><span><i className="icon-Campus"></i> { eventItem.company }</span></li> */}
												<li><span><i className="icon-Campus"></i> <a href={eventItem.location}>{ eventItem.company }</a></span></li>
												<li><span><i className="icon-presentation"></i> { eventItem.category }</span></li>
												{/* <li><span><i className="icon-map-pin-line"></i> {company ? <a href={eventItem.location}>Website</a> : eventItem.location}</span></li> */}
												<li>
													ThisFish delivers smart software solutions that bring transparency and efficiency to seafood supply chains. By digitizing production workflows and enabling real-time traceability, we help seafood companies enhance quality, reduce waste, and meet the growing demand for sustainable, accountable sourcing.
												</li>
											</ul>
											{!company && <div className="read-more-btn mt--45">
												<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
											</div>}
										</div>
									</div>
								</div>
							</div>
							{!company && <div className="col-lg-12">
								<div className="read-more-btn text-center">
									<a className="edu-btn btn-secondary text-center" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</Layout>
			{showRegisterForm && <RegisterProgramForm setShowRegisterForm={setShowRegisterForm} />}
		</>
	)
}
export default SeafoodPropertiesPrediction;